import React from 'react';
import { HelpCircleIcon, LayersIcon, MonitorSmartphoneIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  help: HelpCircleIcon,
  route: RouteIcon,
  screen: MonitorSmartphoneIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-brand-sky text-brand-navy" data-id="element-130" data-mp="2vowogua3en5p">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-131" data-mp="39gkx2nl4uthx">
        <p className="inline-block rounded-md bg-brand-orange px-2 py-0.5 font-sub text-sm font-bold text-brand-navy" data-id="element-132" data-mp="35gu0g38xdj5h">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[1.6rem] leading-[1.1] sm:text-4xl" data-id="element-133" data-mp="3jdzaeebrf260">
          Querés que tus hijos aprendan, desarrollen su creatividad y pasen menos
          tiempo frente a las pantallas,{' '}
          <span className="bg-brand-yellow px-1" data-id="element-134" data-mp="1k3zm02j5ar3x">
            pero no sabés qué actividades ofrecerles.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-135" data-mp="jey8i2b7g3vi">
          Si buscás propuestas educativas para hacer en casa o complementar lo
          que aprenden en la escuela, probablemente conozcas alguna de estas
          situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-136" data-mp="x5bfo2g9vejs">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-brand-navy bg-white p-2.5 text-left" data-id="element-137" data-mp="1726d0i0t78wh" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-brand-orange" data-id="element-138" data-mp="1g2uk0srsc8zv">
                  <Icon size={16} className="text-white" data-id="element-139" data-mp="3dv8lk1no6s6l" />
                </span>
                <div data-id="element-140" data-mp="3hv9520pmltki">
                  <h3 className="font-sub text-sm font-bold leading-tight" data-id="element-141" data-mp="3hwkbk8aghffb">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-142" data-mp="k1pgvw3u06ot">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}